import React from "react";
import { Button, Modal, Form, Input } from "antd";
import { completeCustomerInfo } from "apis/user";
import { showMessage } from "utils";
import { tailFormItemLayout } from "../../../login/layout";

const AlertFn2 = ({ visible, onClose, getData, onSure }) => {
  const onSubmit = values => {
    completeCustomerInfo(values).then(() => {
      showMessage("success", "更改成功");
      onSure();
    });
  };
  console.log(888);
  return (
    <Modal
      title="完善信息"
      closable={false}
      onClose={onClose}
      visible={visible}
      footer={false}
    >
      <Form {...tailFormItemLayout} initialValues={getData} onFinish={onSubmit}>
        <Form.Item
          label="名称"
          name="name"
          rules={[
            {
              required: true,
              message: "请输入名称"
            }
          ]}
        >
          <Input placeholder="请输入名称" />
        </Form.Item>
        <Form.Item
          {...tailFormItemLayout}
          className="btns"
          style={{ textAlign: "right", marginTop: 30 }}
        >
          <Button type="primary" htmlType="submit">
            确认
          </Button>
          <Button
            type="primary"
            className="grayBtn"
            onClick={() => {
              onClose();
            }}
          >
            取消
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AlertFn2;
